"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractInlineTranslation = exports.isInlineTranslation = exports.isInnerTranslation = void 0;
function isInnerTranslation(obj) {
    return (typeof obj === "object" &&
        typeof obj.value === "string" &&
        (obj.locale === undefined || typeof obj.locale === "string"));
}
exports.isInnerTranslation = isInnerTranslation;
function isInlineTranslation(obj) {
    if (!(obj instanceof Array))
        return false;
    for (const elem of obj)
        if (!isInnerTranslation(elem))
            return false;
    return true;
}
exports.isInlineTranslation = isInlineTranslation;
/**
 * @param translation The inner translation object
 * @param locale The locale, like "en_us"
 * @returns The translation value for the given locale. If locale is missing in the inner translation, the default one is returned. If that one is also missing, en_us will be returned.
 */
function extractInlineTranslation(translation, locale) {
    const foundTranslation = translation.find((trans) => trans.locale === locale);
    if (foundTranslation)
        return foundTranslation.value;
    // find default
    const defaultTranslation = translation.find((trans) => trans.locale === undefined);
    if (defaultTranslation)
        return defaultTranslation.value;
    // find for en_us
    const enUs = translation.find((trans) => trans.locale === "en_us");
    if (enUs)
        return enUs.value;
    return undefined;
}
exports.extractInlineTranslation = extractInlineTranslation;
